import {
  EposlovanjeSettings,
  Integration,
  IntegrationGroup,
  IntegrationGroupInfo,
  IntegrationId,
  IntegrationStatus,
  MerSettings,
} from "./types";

// Integration groups data
export const INTEGRATION_GROUPS: IntegrationGroupInfo[] = [
  {
    id: IntegrationGroup.OGLASNICI,
    name: "admin.integration.group.oglasnici",
    description: "admin.integration.group.oglasnici.description",
  },
  {
    id: IntegrationGroup.FINANCIJE,
    name: "admin.integration.group.financije",
    description: "admin.integration.group.financije.description",
  },
  {
    id: IntegrationGroup.OSIGURANJA,
    name: "admin.integration.group.osiguranja",
    description: "admin.integration.group.osiguranja.description",
  },
];

// All available integrations
export const INTEGRATIONS: Integration[] = [
  {
    id: IntegrationId.NJUSKALO,
    name: "Njuškalo",
    description: "admin.integration.njuskalo.description",
    group: IntegrationGroup.OGLASNICI,
    icon: "/media/integrations/njuskalo.png",
    status: IntegrationStatus.NOT_INSTALLED,
  },
  {
    id: IntegrationId.INDEX_OGLASI,
    name: "Index Oglasi",
    description: "admin.integration.indexoglasi.description",
    group: IntegrationGroup.OGLASNICI,
    icon: "/media/integrations/index.svg",
    status: IntegrationStatus.NOT_INSTALLED,
  },
  {
    id: IntegrationId.PLAVI_OGLASNIK,
    name: "Plavi Oglasnik",
    description: "admin.integration.plavioglasnik.description",
    group: IntegrationGroup.OGLASNICI,
    icon: "/media/integrations/plavi-oglasnik.svg",
    status: IntegrationStatus.NOT_INSTALLED,
  },
  {
    id: IntegrationId.MER,
    name: "Mer",
    description: "admin.integration.mer.description",
    group: IntegrationGroup.FINANCIJE,
    icon: "/media/integrations/mer.png",
    status: IntegrationStatus.NOT_INSTALLED,
  },
  {
    id: IntegrationId.EPOSLOVANJE,
    name: "ePoslovanje",
    description: "admin.integration.eposlovanje.description",
    group: IntegrationGroup.FINANCIJE,
    icon: "/media/integrations/eposlovanje.png",
    status: IntegrationStatus.NOT_INSTALLED,
  },
];

// Initial settings for each integration
export const INITIAL_NJUSKALO_SETTINGS = {
  username: "",
  password: "",
};

export const INITIAL_MER_SETTINGS: MerSettings = {
  username: "",
  password: "",
  companyId: "",
  companyBu: "",
  environment: "sandbox",
};

export const INITIAL_EPOSLOVANJE_SETTINGS: EposlovanjeSettings = {
  apiKey: "",
  companyVatId: "",
  businessUnit: "",
  software: "Orytron",
  environment: "sandbox",
};
